import React, { useState, useEffect, useRef } from "react";
import { getIconSrc, getImgSrc } from "../../helpers/getImgSrc";
import "./DropdownFilter.css";

const DropdownFilter = ({ label, options, selectedOption, onSelect, isMultipleselect = true,styling, tour_label="" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tempSelectedOption, setTempSelectedOption] = useState(isMultipleselect ? selectedOption || [] : selectedOption);
  const [searchQuery, setSearchQuery] = useState("");
  const dropdownRef = useRef(null);
  const [menuPosition, setMenuPosition] = useState({});

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      const dropdownRect = dropdownRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const menuWidth = 200; // Adjust this value based on your menu width

      if (dropdownRect.right + menuWidth > viewportWidth) {
        setMenuPosition({ right: 0 });
      } else {
        setMenuPosition({ left: 0 });
      }
    }
  }, [isOpen]);

  const handleApplyFilter = () => {
    onSelect(tempSelectedOption);
    setSearchQuery("")
    setIsOpen(false);
  };

  const handleDeselect = () => {
    onSelect(null);
    setTempSelectedOption(null);
  };

  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className={`dropdown-filter ${tour_label}`} ref={dropdownRef}>
      <div
        className={`dropdown-filter-button`}
        style={styling}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="label">{label}:</div>
        <div className="d-flex justify-content-between" style={{ width: "80px" }}>
          <div  className={`${selectedOption ? "text_primary":"text_color_tertiary"}`}
           style={{ textOverflow: "ellipsis", overflow: "hidden",fontSize:"14px",fontFamily:"aeonik_regular" }}>
            {selectedOption ? selectedOption.label : "Select an option"}
          </div>
          {isOpen ? (
            <img src={getIconSrc("arrow-down", 'svg')} alt="" />
          ) : (
            <img src={getIconSrc("arrow-up", 'svg')} alt="" />
          )}
        </div>
      </div>
      {isOpen && (
        <div className="dropdown-filter-menu shadow-lg" style={menuPosition}>
          <span className="small fw-bold">Type or Select</span>
          
          <div className="dropdown-filter-options-div">
          <input
            type="text"
            className="dropdown-filter-search"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <div className={`dropdown-filter-options ${filteredOptions?.length>0?"has-options":""}`}>
            {filteredOptions.map((option, index) => (
              <div
                key={index}
                className={`dropdown-filter-option small ${option.value === tempSelectedOption?.value ? "selected" : ""}`}
                style={{ cursor: "pointer" }}
                onClick={() => setTempSelectedOption(option)}
              >
                {option.label}
              </div>
            ))}
            </div>
          </div>
          <button className="fapply-filter-btn" onClick={handleApplyFilter}>
            Apply Filter
          </button>
        </div>
      )}
    </div>
  );
};

export default DropdownFilter;